// extracted by mini-css-extract-plugin
module.exports = {"menu":"FidAdminMenu_menu__2oncY","menuItem":"FidAdminMenu_menuItem__36OQu","link":"FidAdminMenu_link__Asx1F","active":"FidAdminMenu_active__3kV05"};